import { render, staticRenderFns } from "./radioList.vue?vue&type=template&id=2b6f6ddd&scoped=true&"
import script from "./radioList.vue?vue&type=script&lang=js&"
export * from "./radioList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f6ddd",
  null
  
)

export default component.exports